import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"page-not-found"},[_c(VRow,{staticClass:"justify-center"},[_c(VCol,{staticClass:"box",attrs:{"cols":"auto"}},[_c('p',{staticClass:"font-weight-black title"},[_vm._v("Oops!")]),_c('p',{staticClass:"description"},[_vm._v(" We cannot seem to find the page you are looking for... ")]),_c('p',{staticClass:"text-subtitle-1"},[_vm._v("Error Code: 404")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }